// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ImportCustomersRequestModel from '../../model/import-customers-request-model';
import ImportCustomersRequestDTO from '../dto/import-customers-request-dto';

export default abstract class ImportCustomersRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ImportCustomersRequestDTO>) {
    super();
    if (data) {
      this.formFile = data.formFile;
    }
  }
  /**
  * @type {binary}
  */
  'formFile'?: File;

  static toModel(dto: DeepPartial<ImportCustomersRequestDTO>): ImportCustomersRequestModel;
  static toModel(dto: DeepPartial<ImportCustomersRequestDTO> | undefined | null): ImportCustomersRequestModel | undefined;
  static toModel(dto: DeepPartial<ImportCustomersRequestDTO> | undefined | null): ImportCustomersRequestModel | undefined {
    return dto ? new ImportCustomersRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ImportCustomersRequestModel> | ImportCustomersRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'formFile': unwrapped.formFile,
    } as ImportCustomersRequestDTO;
  }
}
